<template>
    <span>
        <v-uploader
            url="/mp/imgCommon/crop?type=upload"
            size-limit="2MB"
            type-limit="*.jpg;*.jpeg;*.png;"
            :show-list="false"
            :show-progress="false"
            :auto-upload="false"
            @fileschange="uploadComplete"
        >
            <span class="avatar-opt">
                <v-icon name="basic_camera_fill" remote class="avatar-opt-icon" />
            </span>
            <span slot="manualSubmitter" />
        </v-uploader>
        <v-dialog
            v-model="visiableDialog"
            :mask-closable="false"
            kind="modal"
            class="change-avatar-corp-dialog"
            :title="$t('图片裁剪')"
            :footer-config="{
                primary: {
                    text: $t('确定'),
                    loading: confirmAvatarLoading,
                },
                cancel: {
                    text: $t('取消'),
                },
            }"
            @confirm="handleConfirmAvatar"
        >
            <div class="avatar-select">
                <v-image-cropper
                    v-model="cropperValue"
                    :ratio="1"
                    :width="320"
                    :height="320"
                    :src="imgSrc"
                    class="cropper2"
                />
            </div>
        </v-dialog>
    </span>
</template>
<script>
const UPLOAD_IMG = '/v1/basic/corp/corp/cropImage';
export default {
    data() {
        return {
            imgSrc: '',
            confirmAvatarLoading: false,
            uploading: false,
            visiableDialog: false,
            cropperValue: {
                cropWidth: 60,
                cropHeight: 90,
                cropX: 100,
                cropY: 100,
                rotate: 0,
            },
            blobData: '',
        };
    },

    methods: {
        handleConfirmAvatar(event) {
            event.preventDefault();
            this.confirmAvatarLoading = true;
            const scalc = (1 / this.cropperValue.scale);
            const data = {
                file: this.blobData,
                originWidth: Math.round(scalc * this.cropperValue.cropWidth),
                originHeight: Math.round(scalc * this.cropperValue.cropHeight),
                cropWidth: Math.round(this.cropperValue.cropWidth),
                cropHeight: Math.round(this.cropperValue.cropHeight),
                originX: Math.round(scalc * this.cropperValue.cropX),
                originY: Math.round(scalc * this.cropperValue.cropY),
            };
            const formData = new FormData();
            for (const key in data) {
                formData.append(key, data[key]);
            }
            this.$ajax
                .gatewayPost(UPLOAD_IMG, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    customFn: (res) => {
                        this.confirmAvatarLoading = false;
                        this.$message.error(res.message || this.$t('上传失败'));
                    },
                })
                .then((res) => {
                    this.imgSrc = res.data.show_url;
                    this.$emit('avatarChange', this.imgSrc);
                    this.$message.success(this.$t('上传成功'));
                    this.confirmAvatarLoading = false;
                    this.visiableDialog = false;
                })
                .catch(err => {
                    this.confirmAvatarLoading = false;
                    this.$message.error(err.message || this.$t('上传失败'));
                });
        },
        formImg() {
            this.$nextTick(() => {
                this.visiableDialog = true;
            }, 1000);
        },
        uploadComplete(res) {
            const { error, status, raw } = res[0] || {};
            const reader = new FileReader();
            const that = this;
            switch (status) {
                case 'READY':
                    this.blobData = raw;
                    reader.onload = function () {
                        const img = new Image();
                        img.src = reader.result;
                        that.imgSrc = img.src;
                        that.formImg();
                    };
                    if (this.blobData) {
                        reader.readAsDataURL(this.blobData);
                    }
                    break;
                default:
                    this.$message.error(error.type === 'SIZE' ? this.$t('文件大小超过限制') : error.message || this.$t('上传失败'));
                    break;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.avatar-opt {
    padding: 16px;
    border-radius: var(--radius-round);
    border: var(--border-normal) dashed var(--color-border-normal);
    background: var(--color-bg-1);
    cursor: pointer;

    &-icon {
        vertical-align: middle;
        color: var(--color-text-caption);
    }
}
</style>
<style lang="less">
.change-avatar-corp-dialog .v-image-cropper__toolbar {
    display: none;
}
</style>
